import * as React from "react"
import { Button } from "@/components/ui/shadcn/button"
import { cn } from "@/lib/utils"

interface EmptyStateProps {
    title?: string
    description?: string
    action?: {
        label: string
        onClick: () => void
    }
    icon?: React.ReactNode
    className?: string
}

export function EmptyState({
    title = "No items found",
    description,
    action,
    icon,
    className,
}: EmptyStateProps) {
    return (
        <div
            className={cn(
                "flex flex-col items-center justify-center rounded-md border border-dashed border-muted-foreground/40 p-6 text-center",
                className
            )}
        >
            {icon && <div className="mb-4 text-muted-foreground">{icon}</div>}
            <h3 className="text-sm font-semibold">{title}</h3>
            {description && <p className="mt-1 text-sm text-muted-foreground">{description}</p>}
            {action && (
                <Button
                    variant="outline"
                    className="mt-4"
                    onClick={action.onClick}
                >
                    {action.label}
                </Button>
            )}
        </div>
    )
}






